export const TENDER = "TENDER";
export const CANCEL_TENDER = "CANCEL_TENDER";
